import axios from 'axios';

let prefix = "/gacha-group"

const GachaGroupApi = {
	listGachaGroup(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getGachaGroupInfo(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	archiveGachaGroup(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createGachaGroup(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateGachaGroup(payload) {
		return axios.post(prefix + "/update", payload)
	},

	duplicateGachaGroup(payload) {
		return axios.post(prefix + "/duplicate", payload)
	}
}

export default GachaGroupApi;